import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* packages/miniapp-web-jsapi/src/web/components/modal/Modal.svelte generated by Svelte v3.49.0 */
import { SvelteComponent, append_styles, attr, create_slot, detach, element, get_all_dirty_from_scope, get_slot_changes, init, insert, null_to_empty, safe_not_equal, transition_in, transition_out, update_slot_base } from "svelte/internal";
import { getPrefixCls } from "../../../../lib/web";
import reactToCSS from 'react-style-object-to-css';
function add_css(target) {
  append_styles(target, "svelte-1l3ztq7", ".alipay-mwj-modal.svelte-1l3ztq7{width:100vw;height:100vh;position:fixed;left:0;top:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center}");
}
function create_fragment(ctx) {
  var div;
  var div_class_value;
  var current;
  var default_slot_template = /*#slots*/ctx[7].default;
  var default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[6], null);
  return {
    c: function c() {
      div = element("div");
      if (default_slot) default_slot.c();
      attr(div, "class", div_class_value = "" + (null_to_empty( /*className*/ctx[0] ? "".concat( /*prefixCls*/ctx[2], " ").concat( /*className*/ctx[0]) : /*prefixCls*/ctx[2]) + " svelte-1l3ztq7"));
      attr(div, "style", /*styleString*/ctx[1]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      if (default_slot) {
        default_slot.m(div, null);
      }
      current = true;
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        dirty = _ref2[0];
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/64)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[6], !current ? get_all_dirty_from_scope( /*$$scope*/ctx[6]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[6], dirty, null), null);
        }
      }
      if (!current || dirty & /*className*/1 && div_class_value !== (div_class_value = "" + (null_to_empty( /*className*/ctx[0] ? "".concat( /*prefixCls*/ctx[2], " ").concat( /*className*/ctx[0]) : /*prefixCls*/ctx[2]) + " svelte-1l3ztq7"))) {
        attr(div, "class", div_class_value);
      }
      if (!current || dirty & /*styleString*/2) {
        attr(div, "style", /*styleString*/ctx[1]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  var styleString;
  var _$$props$$$slots = $$props.$$slots,
    slots = _$$props$$$slots === void 0 ? {} : _$$props$$$slots,
    $$scope = $$props.$$scope;
  var prefixCls = getPrefixCls('modal');
  var _$$props$duration = $$props.duration,
    duration = _$$props$duration === void 0 ? undefined : _$$props$duration;
  var _$$props$afterClose = $$props.afterClose,
    afterClose = _$$props$afterClose === void 0 ? function () {} : _$$props$afterClose;
  var _$$props$className = $$props.className,
    className = _$$props$className === void 0 ? '' : _$$props$className;
  var _$$props$style = $$props.style,
    style = _$$props$style === void 0 ? {} : _$$props$style;
  setTimeout(function () {
    if (duration && duration > 0) {
      afterClose();
    }
  }, duration && duration > 0 ? duration : 0);
  $$self.$$set = function ($$props) {
    if ('duration' in $$props) $$invalidate(3, duration = $$props.duration);
    if ('afterClose' in $$props) $$invalidate(4, afterClose = $$props.afterClose);
    if ('className' in $$props) $$invalidate(0, className = $$props.className);
    if ('style' in $$props) $$invalidate(5, style = $$props.style);
    if ('$$scope' in $$props) $$invalidate(6, $$scope = $$props.$$scope);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*style*/32) {
      $: $$invalidate(1, styleString = reactToCSS(_objectSpread({
        zIndex: 999999
      }, style)));
    }
  };
  return [className, styleString, prefixCls, duration, afterClose, style, $$scope, slots];
}
var Modal = /*#__PURE__*/function (_SvelteComponent) {
  _inherits(Modal, _SvelteComponent);
  var _super = _createSuper(Modal);
  function Modal(options) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this);
    init(_assertThisInitialized(_this), options, instance, create_fragment, safe_not_equal, {
      duration: 3,
      afterClose: 4,
      className: 0,
      style: 5
    }, add_css);
    return _this;
  }
  return _createClass(Modal);
}(SvelteComponent);
export default Modal;